import { List, ListItem, ListItemIcon, ListItemText, ListSubheader } from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import links from './links';
import { Trans } from 'react-i18next';

const LinkList = (): JSX.Element => {
  return (
    <List>
      {links.length > 0 && (
        <ListSubheader>
          <ListItemText>
            <Trans>Links</Trans>
          </ListItemText>
        </ListSubheader>
      )}
      {links.map((e, i) => (
        <ListItem key={i} button onClick={() => window.open(e.url, '_blank')}>
          <ListItemIcon>
            <LinkIcon />
          </ListItemIcon>
          <ListItemText>
            <Trans>{e.name}</Trans>
          </ListItemText>
        </ListItem>
      ))}
    </List>
  );
};

export default LinkList;
